(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-buy-box"] && !Shopify.designMode) return;
  try {
    
  class CBBuyBox extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-cb-quantity]');
      if (!this.input) return;

      this.variants = this.querySelector('[data-cb-variants]');
      this.priceOutput = this.querySelector('[data-cb-price]');
      this.compareOutput = this.querySelector('[data-cb-compare]');
      this.stock = this.querySelector('[data-cb-stock]');
      this.stockLabel = this.querySelector('[data-cb-stock-label]');
      this.submit = this.querySelector('[data-cb-submit]');
      this.image = this.querySelector('.cb-buybox__image');

      this.form = this.querySelector('form');

      this.onClick = this.onClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.addEventListener('click', this.onClick);
      if (this.variants) this.variants.addEventListener('change', this.onVariantChange);
      if (this.form && this.dataset.directCheckout === 'true') {
        this.form.addEventListener('submit', this.onSubmit);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.variants) this.variants.removeEventListener('change', this.onVariantChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    async onSubmit(event) {
      const idField = this.form.querySelector('[name="id"]');
      if (!idField || typeof window.fetch !== 'function') return;

      event.preventDefault();

      const id = Number(idField.value);
      const quantity = Math.max(1, Number(this.input.value) || 1);
      if (!id) return;

      if (this.submit) this.submit.disabled = true;

      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] }),
        });

        if (!response.ok) throw new Error('add-to-cart failed');

        window.location.href = '/checkout';
      } catch (error) {
        if (this.submit) this.submit.disabled = false;
        this.form.removeEventListener('submit', this.onSubmit);
        this.form.submit();
      }
    }

    onVariantChange() {
      const option = this.variants.selectedOptions[0];
      if (!option) return;

      const data = option.dataset;
      const available = data.available === 'true';

      if (this.priceOutput) this.priceOutput.textContent = data.price || '';
      if (this.compareOutput) this.compareOutput.textContent = data.compareAt || '';

      if (this.submit) {
        this.submit.disabled = !available;
        this.submit.textContent = available
          ? this.dataset.addLabel || this.submit.textContent
          : this.dataset.soldOutLabel || this.submit.textContent;
      }

      const max = Number(data.max) || 0;
      if (max > 0) {
        this.input.max = String(max);
        if (Number(this.input.value) > max) this.input.value = String(max);
      } else {
        this.input.removeAttribute('max');
      }

      if (this.stock && this.stockLabel) {
        const tracked = data.tracked === 'true';
        const inventory = Number(data.inventory);
        const threshold = Number(this.dataset.lowStockThreshold) || 0;
        let state = 'in';
        let label = this.dataset.inStockLabel || '';

        if (!available) {
          state = 'out';
          label = this.dataset.soldOutLabel || '';
        } else if (tracked && inventory <= threshold) {
          state = 'low';
          label = (this.dataset.lowStockLabel || '').replace('[count]', String(inventory));
        }

        this.stock.className = `cb-buybox__stock cb-buybox__stock--${state}`;
        this.stockLabel.textContent = label;
      }

      if (this.image && data.image) this.image.src = data.image;
    }

    onClick(event) {
      const trigger = event.target.closest('[data-cb-step]');
      if (!trigger) return;

      const delta = Number(trigger.dataset.cbStep) || 0;
      const current = Number(this.input.value) || 1;
      const next = Math.max(1, current + delta);

      if (next !== current) {
        this.input.value = String(next);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (!customElements.get('cb-buy-box')) {
    customElements.define('cb-buy-box', CBBuyBox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-footer-cta"] && !Shopify.designMode) return;
  try {
    
  class CBCta extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.dataset.directCheckout !== 'true') return;

      this.button = this.querySelector('.cb-cta__button');
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    async onSubmit(event) {
      const idField = this.form.querySelector('[name="id"]');
      if (!idField || typeof window.fetch !== 'function') return;

      event.preventDefault();

      const id = Number(idField.value);
      if (!id) return;

      if (this.button) this.button.disabled = true;

      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });

        if (!response.ok) throw new Error('add-to-cart failed');

        window.location.href = '/checkout';
      } catch (error) {
        if (this.button) this.button.disabled = false;
        this.form.removeEventListener('submit', this.onSubmit);
        this.form.submit();
      }
    }
  }

  if (!customElements.get('cb-cta')) {
    customElements.define('cb-cta', CBCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-header"] && !Shopify.designMode) return;
  try {
    
  class CBHeaderDrawer extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onToggle = this.onToggle.bind(this);

      this.addEventListener('click', this.onClick);
      this.details.addEventListener('toggle', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.details.removeEventListener('toggle', this.onToggle);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.classList.remove('cb-drawer-open');
    }

    onToggle() {
      document.documentElement.classList.toggle('cb-drawer-open', this.details.open);
    }

    close() {
      if (this.details.open) this.details.open = false;
    }

    onClick(event) {
      // an in-page anchor does not reload, so the panel would stay open over it
      if (event.target.closest('a') || event.target.closest('[data-cb-drawer-close]')) {
        this.close();
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (!this.details.open) return;

      this.close();

      const toggle = this.querySelector('summary');
      if (toggle) toggle.focus();
    }
  }

  if (!customElements.get('cb-header-drawer')) {
    customElements.define('cb-header-drawer', CBHeaderDrawer);
  }
  class CBHeaderBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sticky !== 'true') return;

      this.offset = Number(this.dataset.stickyOffset) || 0;
      this.wrapper = document.querySelector('.page-wrapper');
      this.onScroll = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.wrapper) this.wrapper.addEventListener('scroll', this.onScroll, { passive: true });

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.wrapper) this.wrapper.removeEventListener('scroll', this.onScroll);
    }

    scrollTop() {
      // Horizon scrolls .page-wrapper on desktop and the document on mobile
      const documentTop = window.scrollY || document.documentElement.scrollTop || 0;
      const wrapperTop = this.wrapper ? this.wrapper.scrollTop : 0;
      return Math.max(documentTop, wrapperTop);
    }

    onScroll() {
      this.classList.toggle('is-stuck', this.scrollTop() > this.offset);
    }
  }

  if (!customElements.get('cb-header-bar')) {
    customElements.define('cb-header-bar', CBHeaderBar);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-reviews"] && !Shopify.designMode) return;
  try {
    
  class CBReviewForm extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cb-review-dialog]');
      if (!this.dialog) return;

      this.form = this.querySelector('form');

      this.onClick = this.onClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onPageShow = this.onPageShow.bind(this);

      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('close', this.onDialogClose);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      window.addEventListener('pageshow', this.onPageShow);

      if (this.querySelector('[data-cb-review-success]')) this.open();

      this.openFromUrl();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.dialog) this.dialog.removeEventListener('close', this.onDialogClose);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    onSubmit() {
      const submit = this.querySelector('[data-cb-review-submit]');
      if (!submit) return;

      submit.classList.add('is-loading');
      submit.setAttribute('aria-busy', 'true');

      // disabling synchronously can cancel the submission in some browsers
      window.setTimeout(function () {
        submit.disabled = true;
      }, 0);
    }

    onPageShow(event) {
      if (!event.persisted) return;

      const submit = this.querySelector('[data-cb-review-submit]');
      if (!submit) return;

      submit.classList.remove('is-loading');
      submit.removeAttribute('aria-busy');
      submit.disabled = false;
    }

    showFields() {
      const fields = this.querySelector('[data-cb-review-fields]');
      if (fields) fields.classList.remove('cb-reviews__fields--hidden');

      const again = this.querySelector('[data-cb-review-again]');
      if (again) again.remove();

      const success = this.querySelector('[data-cb-review-success]');
      if (success) success.remove();

      const first = this.querySelector('.cb-reviews__rating-radio');
      if (first) first.focus();
    }

    onDialogClose() {
      const success = this.querySelector('[data-cb-review-success]');
      if (success) success.remove();
    }

    // Lets a QR code or shared link land straight on the review form,
    // e.g. /?review=open (also accepts the #write-review hash).
    openFromUrl() {
      let requested = false;

      try {
        const url = new URL(window.location.href);
        requested = url.searchParams.get('review') === 'open';
      } catch (error) {
        requested = window.location.search.indexOf('review=open') !== -1;
      }

      if (!requested) requested = window.location.hash === '#write-review';
      if (!requested) return;

      // The dialog is viewport-centred (position: fixed via showModal), so
      // there is nothing to scroll to here. Scrolling would only fight the
      // scroll lock showModal applies. The section is revealed on close.
      this.openedFromUrl = true;
      this.open();

      const first = this.querySelector('.cb-reviews__rating-radio');
      if (first) first.focus();
    }

    open() {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    close() {
      this.dialog.close();
      this.showFields();

      // Someone who arrived from the QR link has never seen the page behind
      // the popup; put them on the reviews section rather than the top.
      if (this.openedFromUrl) {
        this.openedFromUrl = false;
        this.scrollIntoView({ block: 'center', behavior: 'instant' });
      }

      try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('contact_posted') || url.searchParams.has('review')) {
          url.searchParams.delete('contact_posted');
          url.searchParams.delete('review');
          window.history.replaceState({}, '', url.toString() + url.hash);
        }
      } catch (error) {
        // URL API unavailable; the note has already been removed
      }
    }

    onClick(event) {
      if (event.target.closest('[data-cb-review-open]')) {
        event.preventDefault();
        this.open();
        return;
      }

      if (event.target.closest('[data-cb-review-again]')) {
        event.preventDefault();
        this.showFields();
        return;
      }

      if (event.target.closest('[data-cb-review-close]')) {
        event.preventDefault();
        this.close();
      }
    }
  }

  if (!customElements.get('cb-review-form')) {
    customElements.define('cb-review-form', CBReviewForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
